import { Options, Vue } from "vue-class-component";

import List from "@/pages/product-category/list/list.vue";

@Options({
  name: "product-category",
  components: {
    "page-list": List,
  },
})
export default class ProductCategory extends Vue {
  public isIndexOnly() {
    return /^[/]?product-category[/]?$/.test(this.$router.currentRoute.value.path);
  }
}
